import Banner from '@content/ElevateBanner.png';
import Logo from '@content/ElevateLogo.svg';
import { Helmet } from 'react-helmet';

export default () => (
	<Helmet>
		{/* Standard Head Meta */}
		<meta charSet='utf-8' />
		<meta name='viewport' content='width=device-width, initial-scale=1' />
		<meta httpEquiv='Content-Type' content='text/html; text/css; charset=UTF-8' />
		<link rel='canonical' href='https://elevate.jadevelopment.co.uk' />
		<meta httpEquiv='Expires' content='1y' />
		<meta httpEquiv='Pragma' content='1y' />
		<meta httpEquiv='Cache-Control' content='1y' />
		<title>Elevate - Bring everything you need into one place.</title>
		<meta
			name='description'
			content='Elevate is a powerful MIS system designed to revolutionise school management through integration and intelligent functionality. Elevate combines user experience with cutting-edge features, providing staff and students the ability to manage information seamlessly.'
		/>

		{/* Social Media Head Meta */}
		<meta property='og:title' content='Elevate - Bring everything you need into one place.' />
		<meta
			name='og:description'
			content='Elevate is a powerful MIS system designed to revolutionise school management through integration and intelligent functionality. Elevate combines user experience with cutting-edge features, providing staff and students the ability to manage information seamlessly.'
		/>
		<meta property='og:type' content='website' />
		<meta property='og:site_name' content='Elevate by jaDevelopment' />
		<meta property='og:url' content={location.href} />
		<meta property='og:locale' content='en_US' />
		<meta property='og:image' content={Banner} />

		{/* Twitter Head Meta */}
		<meta name='twitter:image' content={Banner} />
		<meta name='twitter:card' content='summary_large_image' />
		<meta name='twitter:site' content='@jadevelopment' />
		<meta name='twitter:title' content='Elevate - Bring everything you need into one place.' />
		<meta name='twitter:alt' content='Elevate by jaDevelopment' />

		{/* Apple Devices Head Meta */}
		<meta name='apple-mobile-web-app-capable' content='yes' />
		<meta name='apple-mobile-web-app-status-bar-style' content='black-translucent' />
		<meta name='apple-mobile-web-app-title' content='Elevate RoMIS by jaDevelopment' />
		<link rel='mask-icon' href={Logo} color='#1c092d' />
		<link rel='apple-touch-icon' href={Logo} />

		{/* Android Devices Head Meta */}
		<meta name='theme-color' content='#1c092d' />
		<meta name='mobile-web-app-capable' content='yes' />

		{/* Windows Devices Head Meta */}
		<meta name='msapplication-TileColor' content='#1c092d' />
		<meta name='msapplication-TileImage' content={Logo} />
		<meta name='msapplication-tap-highlight' content='no' />
	</Helmet>
);
